import { useIntl } from 'react-intl';

const useCustomHomeModalData = () => {
  const intl = useIntl();

  const customModalHomeData = {
    custom_home_modal_admin_title: intl.formatMessage({ id: 'custom-home-modal-admin-title' }),
    custom_home_modal_admin_description: intl.formatMessage({ id: 'custom-home-modal-admin-description' }),
    custom_home_modal_admin_form_status_label_deactivated: intl.formatMessage({ id: 'custom-home-modal-admin-form-status-label-deactivated' }),
    custom_home_modal_admin_form_status_label_activated: intl.formatMessage({ id: 'custom-home-modal-admin-form-status-label-activated' })
  };

  const customModalHomeFormData = [
    { id: 'img', type: 'hidden', label: intl.formatMessage({ id: 'custom-home-modal-admin-form-message-label' }) },
    { id: 'active', label: '' }
  ];

  const customModalHomeFormMessages = {
    custom_home_modal_admin_subbmiting_message: intl.formatMessage({ id: 'custom-home-modal-admin-subbmiting-message' }),
    custom_home_modal_admin_img_loader_info: intl.formatMessage({ id: 'custom-home-modal-admin-img-loader-info' }),
    custom_home_modal_admin_getting_details: intl.formatMessage({ id: 'custom-home-modal-admin-getting-details' }),
    custom_home_modal_admin_image_setting_successfull: intl.formatMessage({ id: 'custom-home-modal-admin-image-setting-successfull' })
  };

  const customModalHomeFormButtons = {
    custom_home_modal_admin_boton_change_img: intl.formatMessage({ id: 'custom-home-modal-admin-boton-change-img' }),
    custom_home_modal_admin_boton_accept: intl.formatMessage({ id: 'custom-home-modal-admin-boton-accept' }),
    custom_home_modal_admin_boton_show_modal: intl.formatMessage({ id: 'custom-home-modal-admin-boton-show-modal' })
  };

  return {
    customModalHomeData,
    customModalHomeFormData,
    customModalHomeFormMessages,
    customModalHomeFormButtons
  };
};

export default useCustomHomeModalData;
